import Modal from '@/src/components/Modal/Modal';

import ReactTooltip from 'react-tooltip';
import ModalHeader from '@/src/components/Modal/ModalHeader';
import CallMeBackForm from '@/src/components/UI/Forms/CallMeBackForm';
import React, { FC } from 'react';
import Image from 'next/image';
import { Agent } from '@/swagger';
import Flexbox from '@/components/common/Flexbox';
import clsx from 'clsx';
import { QRCodeSVG } from 'qrcode.react';

interface ModalPopupProps {
  showCallMeBackForm: boolean;
  setShowCallMeBackForm: (value: boolean) => void;
  showLinePopup: boolean;
  setShowLinePopup: (value: boolean) => void;
  agent: Agent;
  needAddress?: boolean;
  listingId?: string;
}

const ModalPopup: FC<ModalPopupProps> = ({
  showCallMeBackForm,
  setShowCallMeBackForm,
  showLinePopup,
  setShowLinePopup,
  needAddress,
  listingId,
}) => {
  return (
    <div>
      <Modal show={showCallMeBackForm} zIndex={9999}>
        <CallMeBackForm
          closeBtnPress={() => setShowCallMeBackForm(false)}
          needAddress={needAddress}
          listingId={listingId}
        />
      </Modal>
      <ReactTooltip backgroundColor='black' place={'bottom'} />
      <LinePopup
        showLinePopup={showLinePopup}
        setShowLinePopup={setShowLinePopup}
        lineQR={'https://line.me/ti/p/@funwoo'}
      />
    </div>
  );
};
export const LinePopup = ({
  showLinePopup,
  lineQR,
  setShowLinePopup,
}: {
  lineQR: string;
  showLinePopup: boolean;
  setShowLinePopup: (value: boolean) => void;
}) => {
  return (
    <Modal show={showLinePopup} zIndex={100}>
      <div className={' w-100 h-5/6 bg-white'}>
        <ModalHeader closeBtnPress={() => setShowLinePopup(false)} title={`掃描 QR 碼聯絡 客服專員`} />
        <div className={'flex justify-center w-full h-full items-center'}>
          <FunwooLineQRCode lineQR={lineQR} className={clsx('w-64 h-64')} size={256} />
        </div>
      </div>
    </Modal>
  );
};
export default ModalPopup;

export const FunwooLineQRCode: React.FC<{
  className?: string;
  lineQR: string;
  size?: number;
}> = ({ className, lineQR, size }) => {
  return (
    <Flexbox align={'center'} justify={'center'} className={clsx('relative', className)}>
      <QRCodeSVG style={{ position: 'relative' }} size={size} value={lineQR} />
      <Flexbox align={'center'} justify={'center'} className={clsx('absolute w-full h-full', 'z-50')}>
        <Flexbox
          align={'center'}
          justify={'center'}
          className={clsx('border border-gray300 rounded-md', 'w-[20%] h-[20%]', 'bg-white', 'p-1')}
        >
          <Image src={'/line-logo.png'} width={30} height={30} />
        </Flexbox>
      </Flexbox>
    </Flexbox>
  );
};
